

























































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ImportacaoPagamentosStore from '@/components/RemuneracaoMedica/financeiro/Store/ImportacaoPagamentosStore'
import NovaImportacaoModal from '@/components/RemuneracaoMedica/financeiro/components/NovaImportacaoModal.vue'
import ImportacaoDetalheModal from '@/components/RemuneracaoMedica/financeiro/components/ImportacaoDetalheModal.vue'
import StatusChip from '@/components/RemuneracaoMedica/financeiro/components/StatusChip.vue'
import EventBus from '@/plugins/EventBus'
import { RequestMessage } from '@/types/_'
import { maskDateTime } from '@/utils/common'
import { STATUS_IMPORTACAO_OPTIONS,
  isImportacaoEmAndamento,
  statusImportacaoCor,
  statusImportacaoLabel,
  tipoImportacaoLabel } from '@/utils/importacaoPagamentos'

const POLLING_INTERVAL_MS = 20000

@Component({
  components: {
    NovaImportacaoModal,
    ImportacaoDetalheModal,
    StatusChip,
  },
})
export default class ViewFinanceiroImportacaoPagamentos extends Vue {
  loadingDataTable: boolean = false
  pollingTimer: any = null

  statusImportacaoCor = statusImportacaoCor
  statusImportacaoLabel = statusImportacaoLabel
  tipoImportacaoLabel = tipoImportacaoLabel

  get store() {
    return getModule(ImportacaoPagamentosStore, this.$store)
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get statusOptions() {
    return STATUS_IMPORTACAO_OPTIONS
  }

  get items() {
    return this.store.importacoesList
  }

  get headers() {
    return [
      { text: 'Arquivo', value: 'nomeArquivo', align: 'left', sortable: false },
      { text: 'Tipo', value: 'tipoImportacao', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Total', value: 'totalRegistros', align: 'center', sortable: false },
      { text: 'Processados', value: 'registrosProcessados', align: 'center', sortable: false },
      { text: 'Com falha', value: 'registrosComFalha', align: 'center', sortable: false },
      { text: 'Criado em', value: 'criadoEm', align: 'center', sortable: false },
      { text: 'Criado por', value: 'criadoPor', align: 'center', sortable: false },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false },
    ]
  }

  get filtroStatus() {
    return this.store.filtroStatus
  }

  set filtroStatus(value: any) {
    this.store.setFiltroStatus(value)
  }

  get getPagina() {
    return this.store.pagina
  }

  set getPagina(value: number) {
    this.store.setPagina(value)
  }

  get itemsLength() {
    return Math.ceil(this.store.totalRegistros / this.store.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.store.getImportacoes()
    this.loadingDataTable = false
    this.avaliarPolling()
  }

  async filtrarPorStatus() {
    this.store.setPagina(1)
    await this.getResults(1)
  }

  abrirNovaImportacao() {
    this.store.setModalNovaImportacao(true)
  }

  async onUploaded() {
    this.store.setPagina(1)
    await this.getResults(1)
  }

  async verDetalhe(item: any) {
    this.store.setImportacaoSelecionada(item)
    this.store.resetItens()
    this.store.setModalDetalhe(true)
    await this.store.getImportacaoItens()
  }

  // ---- Polling ----
  temImportacaoEmAndamento(): boolean {
    return this.items.some((item: any) => isImportacaoEmAndamento(item.status))
  }

  avaliarPolling() {
    if (this.temImportacaoEmAndamento()) {
      this.startPolling()
    } else {
      this.stopPolling()
    }
  }

  startPolling() {
    if (this.pollingTimer) return
    this.pollingTimer = setInterval(async () => {
      await this.store.getImportacoes()
      if (!this.temImportacaoEmAndamento()) {
        this.stopPolling()
      }
    }, POLLING_INTERVAL_MS)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.init.text,
    })
    await this.store.getImportacoes()
    EventBus.$emit('clearLoadingRequest')
    this.avaliarPolling()
  }

  beforeDestroy() {
    this.stopPolling()
  }
}
